
var placeholderIcon = '/Assets/Images/other-C0D0EB.png';

var selectedFilters = [];

var renderedVacancies = [];

window.RequestApi = async function (apiUrl, successElem){

    return new Promise((resolve, reject) => {
        fetch(apiUrl)
        .then( res => res.json() )
        .then(response => {
            resolve(response);
            
        }).catch(function(error) {
            resolve(null);
        })
      });
}

window.PopulateVacancies = async (vacancies, departments) => {
    
    let vacancyTemplate = Handlebars.compile(document.querySelector('#vacancies-template').innerHTML);

    for(var vacancy of vacancies){

        var depMatched = false;

        if(vacancy['department'] === ''){
            vacancy['department-mobile'] = 'Other';
        }else{
            vacancy['department-mobile'] = vacancy['department'];
        }

        for(var dep of departments){
            if((vacancy['department'] === '' && dep['Title'].toLowerCase() == 'other') || dep['Title'].toLowerCase() == vacancy['department'].toLowerCase()){
                depMatched = true;

                vacancy['colourcode'] = dep['ColourCode'];
                if(dep['ImageModel']['Url'] == null){
                    vacancy['imageurl'] = placeholderIcon;
                }else{
                    vacancy['imageurl'] = dep['ImageModel']['Url'];
                }
            }
        }

        if(!depMatched){
            vacancy['imageurl'] = placeholderIcon;
        }
    }
   
    //go ahead, we have data
    for (var vacancy of vacancies) {
        hideElement('vacancies-messages');
        appendContents('vacancies-content', vacancyTemplate(vacancy));
    }
}

window.PopulateFilters = (vacancies) => {

    var populatedList = [];
    
    for (var vacancy of vacancies){
        
        var department = vacancy['department'];

        if(department === ''){
            department = 'Other';
        }

        if(populatedList.indexOf(department) < 0){
            populatedList.push(department);
        }
    }
    return populatedList;
}

window.RenderFilters = (filterList) => {

    //Create the filter element and insert

    for (var filter in filterList) {
        var currentFilter = filterList[filter];
        let tickItem = document.createElement('span');
        tickItem.classList.add('checkmark');
        let filterItem = document.createElement('span');
        filterItem.setAttribute('id', currentFilter);
        filterItem.classList.add('filter-pill');
        filterItem.appendChild(tickItem);

        filterItem.onclick = (function(currentFilter){
            return function(){window.filterVacancies(currentFilter)}
            })(currentFilter);

        filterItem.append(currentFilter);
        document.getElementById('vacancyFilters').appendChild(filterItem);

    }
}

window.filterVacancies = (filterChoice) => {

    renderedVacancies = document.getElementsByClassName('vacancy');
    
    if(filterChoice === ''){
        
        //if they have selected 'all'
        document.getElementById('all-filter').classList.add('active-filter');

        for(var filter in selectedFilters){
            document.getElementById(selectedFilters[filter]).classList.remove('active-filter');
        }

        selectedFilters = [];

        for(var i = 0;i<renderedVacancies.length;i++){
            renderedVacancies[i].classList.remove('d-none');
        }

    }else{

        //a specific filter was selected

        document.getElementById('all-filter').classList.remove('active-filter');

        //first set state of filters
        if(selectedFilters.indexOf(filterChoice) < 0){
            selectedFilters.push(filterChoice);
            document.getElementById(filterChoice).classList.add('active-filter');
        } else{
            selectedFilters.splice(selectedFilters.indexOf(filterChoice),1);//
            document.getElementById(filterChoice).classList.remove('active-filter');
        }

        if(Object.keys(selectedFilters).length == 0){
            
            //if there are no selected filters, then all items show
            try{
                for(var i = 0;i<renderedVacancies.length;i++){
                    renderedVacancies[i].classList.remove('d-none');
                }
            }catch{

            }

            document.getElementById('all-filter').classList.add('active-filter');

        }else{

            for(var i = 0;i<renderedVacancies.length;i++){

                if(Object.keys(selectedFilters).length > 0){
                    
                    var depAttribute = (renderedVacancies[i]).getAttribute("data-department");
                    
                    if(selectedFilters.indexOf(depAttribute) >= 0 || (depAttribute == '' && selectedFilters.indexOf('Other') >= 0)){
                        renderedVacancies[i].classList.remove('d-none');
                        
                    } else{
                        renderedVacancies[i].classList.add('d-none');
                    }
                }else{
                    renderedVacancies[i].classList.remove('d-none');
                }

            }
        }
    }
}

window.RetrieveVacancies = async (errorMessage, noResultsMessage) => { 

    var vacancies = await RequestApi('/feeds/vacancies', document.getElementById('vacancies-content'));

    //We should get null back in the event of an error
    if (vacancies == null) {

        hideElement('vacancies-content');
        showElement('no-vacancy-btn');
        setContents('vacancies-message-content', errorMessage);

    } else {
    
        var vacLength = Object.keys(vacancies).length;

        //if we get back empty json, there are no vacancies
        if (vacLength == 0) {

            hideElement('vacancies-content');
            showElement('no-vacancy-btn');
            setContents('vacancies-message-content', noResultsMessage)

        }else{

            return vacancies;

        }
    }

};


window.RetrieveArticles = async (noResultsMessage,pageNumber,pageSize,author, filters) => { 

    var filterQS = 'topics=';
    if(filters.length > 0){
        filters.forEach(element => {
            filterQS += element + ',';
        });
    }

    var articles = await RequestApi('/feeds/articles/?'+filterQS+'&page='+pageNumber+'&pageSize='+pageSize+'&authorGuid='+author, document.getElementById('articles-content'));

    //We should get null back in the event of an error
    if (articles == null) {

        hideElement('articles-content');
        setContents('articles-message-content', noResultsMessage);

    } else {
    
        var vacLength = Object.keys(articles).length;

        //if we get back empty json, there are no articles
        if (vacLength == 0) {

            hideElement('articles-content');
            showElement('no-vacancy-btn');
            setContents('articles-message-content', noResultsMessage)

        }else{

            return articles;

        }
    }

};

window.RetrieveTeasers = async (noResultsMessage,pageNumber,pageSize,directoryReference, filters, articleListType) => { 

    var filterQS = 'topics=';
    if(filters.length > 0){
        filters.forEach(element => {
            filterQS += element + ',';
        });
    }

    var articles = await RequestApi('/feeds/articleTeasers/?'+filterQS+'&page='+pageNumber+'&pageSize='+pageSize+'&directoryReference='+directoryReference+'&articleListType='+articleListType, document.getElementById('articles-content'));
    
    //We should get null back in the event of an error
    if (articles == null) {
    
        //hideElement('articles-content');
        setContents('articles-message-content', noResultsMessage);

    } else {
        
        hideElement('articles-message-content');
        
        var vacLength = Object.keys(articles).length;

        //if we get back empty json, there are no articles
        if (vacLength == 0) {

            setContents('articles-message-content', noResultsMessage)

        }else{

            return articles;

        }
    }

};


window.PopulateArticles = async (articlesContainerData, topics, append = false) => {

    var articles = articlesContainerData.articles;

    let articleTemplate = Handlebars.compile(document.querySelector('#articlelist-template').innerHTML);

    if(!append){
        //clear the contents before appending the articles
        setContents('articles-content', '');
    }


    //go ahead, we have data
    for (var article of articles.results) {
        hideElement('articles-messages');
        appendContents('articles-content', articleTemplate(article));
    }
}